import { HTTP } from '../../http-common'

export default {
  state: {
    loadedWalls: []
  },
  getters: {
    loadedWalls (state) {
      return state.loadedWalls
    }
  },
  mutations: {
    setLoadedWalls (state, payload) {
      state.loadedWalls = payload
    },
    createWall (state, payload) {
      state.loadedWalls.push(payload)
    },
    updateWall (state, payload) {
      state.loadedWalls = state.loadedWalls.map(wall => wall.id === payload.id ? payload : wall)
    },
    removeWall (state, id) {
      state.loadedWalls = state.loadedWalls.filter(wall => {
        return wall.id !== id
      })
    },
    clearLoadedWalls (state) {
      state.loadedWalls = []
    }
  },
  actions: {
    loadWalls ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedWalls', [])

      return new Promise((resolve, reject) => {
        HTTP.get('wall_type.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedWalls', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createWall ({ commit, getters }, payload) {
      console.log('createWall')
      commit('clearError')
      commit('setLoading', true)
      const newWall = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('wall_type.json/', newWall)
          .then(result => {
            console.log(result)
            commit('createWall', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateWall ({ commit, getters }, payload) {
      console.log('updateWall')
      commit('clearError')
      commit('setLoading', true)
      const wall = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`wall_type.json/${payload.id}/`, wall)
          .then(result => {
            console.log(result)
            commit('updateWall', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeWall ({ commit }, payload) {
      console.log('removeWall')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`wall_type.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeWall', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedWalls ({ commit }) {
      commit('clearLoadedWalls')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/wall/index.js